import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { history } from 'store';
import { formatCoordinate, valueToLabel, capitalizeString } from 'common/utils';
import {
  Card,
  BannerComponent,
  Dropdown,
  IconList,
  LevelNav,
} from 'common/components';
import { SocialShare } from 'containers';
import { ROUTE_FIELDS, ROUTE_FIELDS_EDIT } from 'common/constants';
import { base64url_encode } from 'util/base64';
import * as icons from 'common/svg/icons';

const Details = ({ field }) => {
  const list = [
    {
      icon: 'fields',
      label: (
        <span className="has-text-weight-bold text--title-case">
          {field.size.size} {valueToLabel(field.size.type)}
        </span>
      ),
    },
    {
      icon: 'coordinates',
      label: `${formatCoordinate(field.location.lat)}, ${formatCoordinate(
        field.location.lng
      )}`,
    },
  ];

  field.identification &&
    list.push({ icon: 'target', label: field.identification });
  list.push({ label: capitalizeString(valueToLabel(field.ownership)) });
  field.notes && list.push({ label: field.notes });

  return (
    field && (
      <Card>
        <IconList list={list} />
      </Card>
    )
  );
};

const FieldDetails = ({ field, deleteAction, id, season }) => {
  const tools = (
    <Fragment>
      <SocialShare id={id} season={season} />
      <Dropdown
        className="level-right"
        theme={['right', 'medium', 'invert']}
        trigger={<icons.kebab />}
      >
        <IconList
          list={[
            {
              label: 'Edit',
              icon: 'edit',
              action: () => {
                history.push(`${ROUTE_FIELDS_EDIT}/${base64url_encode(id)}`);
              },
            },
            { label: 'Delete', icon: 'garbage', action: () => deleteAction() },
          ]}
          theme={['medium']}
        />
      </Dropdown>
    </Fragment>
  );

  return (
    <div className={'bg--primary'}>
      <BannerComponent
        theme={['strong', 'static', 'mobile-fixed']}
        message={
          <LevelNav
            nav={{
              left: {
                element: (
                  <Link
                    className="chevron chevron--left chevron--invert"
                    to={ROUTE_FIELDS}
                  >
                    <span className={'visible--desktop'}>Field List</span>
                  </Link>
                ),
              },
              center: { label: field && field.name },
              right: { element: tools },
            }}
          />
        }
      />

      <div className={'column__inner'}>
        <section className={'cardlist__item'}>
          {field && <Details field={field} />}
        </section>
      </div>
    </div>
  );
};

FieldDetails.propTypes = {
  field: PropTypes.object,
  deleteAction: PropTypes.func,
  id: PropTypes.string.isRequired,
  season: PropTypes.number.isRequired,
};

export default FieldDetails;



// WEBPACK FOOTER //
// ./src/containers/FieldDetails/index.js